import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from '../residue/url_helper';
import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_RESIDUE_API_URL);

export const stringifyParams = params => qs.stringify(params, { encodeValuesOnly: true });

// Final Destinations
export const getFinalDestinationList = (params) => {
    return apiClient.get(
        `${url.GET_FINAL_DESTINATIONS}?${stringifyParams(params)}`
    );
}
export const getFinalDestination = finalDestination => apiClient.get(url.FINAL_DESTINATION + '/' + encodeURIComponent(finalDestination));
export const existsFinalDestination = rut => apiClient.get(url.EXISTS_FINAL_DESTINATION + '/' + encodeURIComponent(rut));
export const addNewFinalDestination = finalDestination => apiClient.post(url.ADD_FINAL_DESTINATION, finalDestination);
export const updateFinalDestination = finalDestination => apiClient.put(url.UPDATE_FINAL_DESTINATION + '/' + finalDestination._id, finalDestination);
export const deleteFinalDestination = finalDestination => apiClient.delete(url.DELETE_FINAL_DESTINATION + '/' + finalDestination._id);

// Final Destination Types
export const getFinalDestinationTypeList = () => apiClient.get(url.GET_FINAL_DESTINATION_TYPES);
export const getFinalDestinationType = finalDestinationType => apiClient.get(url.FINAL_DESTINATION_TYPE + '/' + encodeURIComponent(finalDestinationType));
export const addNewFinalDestinationType = finalDestinationType => apiClient.post(url.ADD_FINAL_DESTINATION_TYPE, finalDestinationType);
export const updateFinalDestinationType = finalDestinationType => apiClient.put(url.UPDATE_FINAL_DESTINATION_TYPE + '/' + finalDestinationType._id, finalDestinationType);
export const deleteFinalDestinationType = finalDestinationType => apiClient.delete(url.DELETE_FINAL_DESTINATION_TYPE + '/' + finalDestinationType._id);

// Residue Types
export const getResidueTypeList = (params) => {
    return apiClient.get(
        `${url.GET_RESIDUE_TYPES}?${stringifyParams(params)}`
    );
}
export const getResidueType = residueType => apiClient.get(url.RESIDUE_TYPE + '/' + encodeURIComponent(residueType));
export const addNewResidueType = residueType => apiClient.post(url.ADD_RESIDUE_TYPE, residueType);
export const updateResidueType = residueType => apiClient.put(url.UPDATE_RESIDUE_TYPE + '/' + residueType._id, residueType);
export const deleteResidueType = residueType => apiClient.delete(url.DELETE_RESIDUE_TYPE + '/' + residueType._id);

// Residue Categories
export const getResidueCategoryList = (params) => {
    return apiClient.get(
        `${url.GET_RESIDUE_CATEGORIES}?${stringifyParams(params)}`
    );
}
export const getResidueCategory = residueCategory => apiClient.get(url.RESIDUE_CATEGORY + '/' + encodeURIComponent(residueCategory));
export const addNewResidueCategory = residueCategory => apiClient.post(url.ADD_RESIDUE_CATEGORY, residueCategory);
export const updateResidueCategory = residueCategory => apiClient.put(url.UPDATE_RESIDUE_CATEGORY + '/' + residueCategory._id, residueCategory);
export const deleteResidueCategory = residueCategory => apiClient.delete(url.DELETE_RESIDUE_CATEGORY + '/' + residueCategory._id);

// Unit Measurements
export const getUnitMeasurementList = () => apiClient.get(url.GET_UNIT_MEASUREMENTS);
export const getUnitMeasurement = unitMeasurement => apiClient.get(url.UNIT_MEASUREMENT + '/' + encodeURIComponent(unitMeasurement));
export const getUnitMeasurementByCode = code => apiClient.get(url.UNIT_MEASUREMENT_BY_CODE + '/' + encodeURIComponent(code));
export const addNewUnitMeasurement = unitMeasurement => apiClient.post(url.ADD_UNIT_MEASUREMENT, unitMeasurement);
export const updateUnitMeasurement = unitMeasurement => apiClient.put(url.UPDATE_UNIT_MEASUREMENT + '/' + unitMeasurement._id, unitMeasurement);
export const deleteUnitMeasurement = unitMeasurement => apiClient.delete(url.DELETE_UNIT_MEASUREMENT + '/' + unitMeasurement._id);

// Residues
export const getResidueList = (params) => {    return apiClient.get(        `${url.GET_RESIDUES}?${stringifyParams(params)}`    );}
export const getResidue = residue => apiClient.get(url.RESIDUE + '/' + encodeURIComponent(residue));
export const addNewResidue = residue => apiClient.post(url.ADD_RESIDUE, residue);
export const updateResidue = residue => apiClient.put(url.UPDATE_RESIDUE + '/' + residue._id, residue);
export const deleteResidue = residue => apiClient.delete(url.DELETE_RESIDUE + '/' + residue._id);

// Guides
export const getGuideList = (params) => { return apiClient.get(`${url.GET_GUIDES}?${stringifyParams(params)}`); }
// Guides — GET /guide/flat: scope query params + OData `pagination` / `sort`
export const getGuidesFlat = params => {
	return apiClient.get(`${url.GET_GUIDES_FLAT}?${stringifyParams(params)}`);
};
export const getGuide = guide => apiClient.get(url.GUIDE + '/' + encodeURIComponent(guide));
export const addNewGuide = guide => apiClient.post(url.ADD_GUIDE, guide);
export const updateGuide = guide => apiClient.put(url.UPDATE_GUIDE + '/' + guide._id, guide);
export const deleteGuide = guide => apiClient.delete(url.DELETE_GUIDE + '/' + guide._id);
export const cancelWarehouseSendFromStock = (guideId, body) =>
	apiClient.post(
		`${url.CANCEL_WAREHOUSE_SEND_GUIDE}/${encodeURIComponent(guideId)}/cancel_warehouse_send`,
		body,
	);
export const getRegisterGuide = guide => apiClient.get(url.REGISTER_GUIDE + '/' + encodeURIComponent(guide));
export const registerGuide = guide => apiClient.post(url.REGISTER_GUIDE, guide);
export const warehouseReceptionGuide = dataGuides => apiClient.post(url.WAREHOUSE_RECEPTION_GUIDE, dataGuides);
export const warehouseSendGuide = dataGuides => apiClient.post(url.WAREHOUSE_SEND_GUIDE, dataGuides);
export const finalDestinationReceptionGuide = dataGuides => apiClient.post(url.FINAL_DESTINATION_RECEPTION_GUIDE, dataGuides);
export const finalDestinationPrecertificationGuide = dataGuides => apiClient.post(url.FINAL_DESTINATION_PRECERTIFICATION_GUIDE, dataGuides);
export const finalDestinationCertificationGuide = dataGuides => apiClient.post(url.FINAL_DESTINATION_CERTIFICATION_GUIDE, dataGuides);
export const statementGuide = dataGuides => apiClient.post(url.STATEMENT_GUIDE, dataGuides);
export const getDetailGuide = guide => apiClient.get(url.DETAILS_GUIDE + '/' + encodeURIComponent(guide));

export const getFolderPaths = ({ ids, middle_path }) => {
    return apiClient.post(
        url.GUIDE_FOLDER_PATH,
        { ids, middle_path }  // Request body
    );
};

export const getStatusGuide = (params) => { return apiClient.get(`${url.GET_STATUS_GUIDE}?${stringifyParams(params)}`); }


// Guide Details
export const getGuideDetailList = (params) => {
    return apiClient.get(
        `${url.GET_GUIDE_DETAILS}?${stringifyParams(params)}`
    );
}
export const getGuideDetail = guideDetail => apiClient.get(url.GUIDE_DETAIL + '/' + encodeURIComponent(guideDetail));
export const addNewGuideDetail = guideDetail => apiClient.post(url.ADD_GUIDE_DETAIL, guideDetail);
export const updateGuideDetail = guideDetail => apiClient.put(url.UPDATE_GUIDE_DETAIL + '/' + guideDetail._id, guideDetail);
export const deleteGuideDetail = guideDetail => apiClient.delete(url.DELETE_GUIDE_DETAIL + '/' + guideDetail._id);
export const warehouseSendGuideDetail = dataGuideDetails => apiClient.post(url.WAREHOUSE_SEND_GUIDE_DETAIL, dataGuideDetails);

// Traceability
export const getGuideTrace = (guideId, params = {}) =>
	apiClient.get(
		`${url.GUIDE}/${encodeURIComponent(guideId)}/trace?${stringifyParams(params)}`
	);
export const getWarehouseResidueMovementList = (params) =>
	apiClient.get(
		`${url.GET_WAREHOUSE_RESIDUE_MOVEMENTS}?${stringifyParams(params)}`
	);

// Management
export const getManagementList = (params) => { return apiClient.get(`${url.GET_MANAGEMENTS}?${stringifyParams(params)}`); }
export const getManagement = management => apiClient.get(url.MANAGEMENT + '/' + encodeURIComponent(management));
export const addNewManagement = management => apiClient.post(url.ADD_MANAGEMENT, management);
export const updateManagement = management => apiClient.put(url.UPDATE_MANAGEMENT + '/' + management._id, management);
export const deleteManagement = management => apiClient.delete(url.DELETE_MANAGEMENT + '/' + management._id);

// Treatment
export const getTreatmentList = (params) => {
    return apiClient.get(
        `${url.GET_TREATMENTS}?${stringifyParams(params)}`
    );
}
export const getTreatment = treatment => apiClient.get(url.TREATMENT + '/' + encodeURIComponent(treatment));
export const addNewTreatment = treatment => apiClient.post(url.ADD_TREATMENT, treatment);
export const updateTreatment = treatment => apiClient.put(url.UPDATE_TREATMENT + '/' + treatment._id, treatment);
export const deleteTreatment = treatment => apiClient.delete(url.DELETE_TREATMENT + '/' + treatment._id);

// Treatment Detail
export const getTreatmentDetailList = (params) => {
    return apiClient.get(
        `${url.GET_TREATMENT_DETAILS}?${stringifyParams(params)}`
    );
}
export const getTreatmentDetail = treatmentDetail => apiClient.get(url.TREATMENT_DETAIL + '/' + encodeURIComponent(treatmentDetail));
export const addNewTreatmentDetail = treatmentDetail => apiClient.post(url.ADD_TREATMENT_DETAIL, treatmentDetail);
export const updateTreatmentDetail = treatmentDetail => apiClient.put(url.UPDATE_TREATMENT_DETAIL + '/' + treatmentDetail._id, treatmentDetail);
export const deleteTreatmentDetail = treatmentDetail => apiClient.delete(url.DELETE_TREATMENT_DETAIL + '/' + treatmentDetail._id);

// Assignation Management Residue Final Destination
export const getAssignationManagementResidueFinalDestinationList = (params) => {
    return apiClient.get(
        `${url.GET_ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATIONS}?${stringifyParams(params)}`
    );
}
export const getAssignationManagementResidueFinalDestination = assignationManagementResidueFinalDestination => apiClient.get(url.ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATION + '/' + encodeURIComponent(assignationManagementResidueFinalDestination));
export const addNewAssignationManagementResidueFinalDestination = assignationManagementResidueFinalDestination => apiClient.post(url.ADD_ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATION, assignationManagementResidueFinalDestination);
export const updateAssignationManagementResidueFinalDestination = assignationManagementResidueFinalDestination => apiClient.put(url.UPDATE_ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATION + '/' + assignationManagementResidueFinalDestination._id, assignationManagementResidueFinalDestination);
export const deleteAssignationManagementResidueFinalDestination = assignationManagementResidueFinalDestination => apiClient.delete(url.DELETE_ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATION + '/' + assignationManagementResidueFinalDestination._id);
export const registerAssignationManagementResidueFinalDestination = assignationManagementResidueFinalDestination => apiClient.post(url.REGISTER_ASIGNATIONS_MANAGEMENT_RESIDUE_FINAL_DESTINATION, assignationManagementResidueFinalDestination);

// Statement
export const getStatementList = (params) => {
    return apiClient.get(
        `${url.GET_STATEMENTS}?${stringifyParams(params)}`
    );
}
export const getStatement = statement => apiClient.get(url.STATEMENT + '/' + encodeURIComponent(statement));
export const addNewStatement = statement => apiClient.post(url.ADD_STATEMENT, statement);
export const updateStatement = statement => {
    console.log('bh: ', statement)
    return apiClient.put(url.UPDATE_STATEMENT + '/' + statement._id, statement);
}
export const deleteStatement = statement => apiClient.delete(url.DELETE_STATEMENT + '/' + statement._id + '/');
export const getDataResiduesStatement = statement => apiClient.get(url.STATEMENT + '/' + encodeURIComponent(statement) + '/data_residues');

// Status Statement
export const getStatusStatementList = (params) => {
    return apiClient.get(
        `${url.GET_STATUS_STATEMENTS}?${stringifyParams(params)}`
    );
}
export const getStatusStatement = status_statement => apiClient.get(url.STATUS_STATEMENT + '/' + encodeURIComponent(status_statement));
export const addNewStatusStatement = status_statement => apiClient.post(url.ADD_STATUS_STATEMENT, status_statement);
export const updateStatusStatement = status_statement => apiClient.put(url.UPDATE_STATUS_STATEMENT + '/' + status_statement._id, status_statement);
export const deleteStatusStatement = status_statement => apiClient.delete(url.DELETE_STATUS_STATEMENT + '/' + status_statement._id);

// Beach Cleaning Helpers

// Origin Type
export const getOriginTypeList = (params) => {
    return apiClient.get(
        `${url.GET_ORIGIN_TYPES}?${stringifyParams(params)}`
    );
}
export const getOriginType = originType => apiClient.get(url.ORIGIN_TYPE + '/' + encodeURIComponent(originType));
export const addNewOriginType = originType => apiClient.post(url.ADD_ORIGIN_TYPE, originType);
export const updateOriginType = originType => apiClient.put(url.UPDATE_ORIGIN_TYPE + '/' + originType._id, originType);
export const deleteOriginType = originType => apiClient.delete(url.DELETE_ORIGIN_TYPE + '/' + originType._id);

// Beach Cleaning Reason
export const getBeachCleaningReasonList = (params) => {
    return apiClient.get(
        `${url.GET_BEACH_CLEANING_REASONS}?${stringifyParams(params)}`
    );
}
export const getBeachCleaningReason = beachCleaningReason => apiClient.get(url.BEACH_CLEANING_REASON + '/' + encodeURIComponent(beachCleaningReason));
export const addNewBeachCleaningReason = beachCleaningReason => apiClient.post(url.ADD_BEACH_CLEANING_REASON, beachCleaningReason);
export const updateBeachCleaningReason = beachCleaningReason => apiClient.put(url.UPDATE_BEACH_CLEANING_REASON + '/' + beachCleaningReason._id, beachCleaningReason);
export const deleteBeachCleaningReason = beachCleaningReason => apiClient.delete(url.DELETE_BEACH_CLEANING_REASON + '/' + beachCleaningReason._id);

// Record Type
export const getRecordTypeList = (params) => {
    return apiClient.get(
        `${url.GET_RECORD_TYPES}?${stringifyParams(params)}`
    );
}
export const getRecordType = recordType => apiClient.get(url.RECORD_TYPE + '/' + encodeURIComponent(recordType));
export const addNewRecordType = recordType => apiClient.post(url.ADD_RECORD_TYPE, recordType);
export const updateRecordType = recordType => apiClient.put(url.UPDATE_RECORD_TYPE + '/' + recordType._id, recordType);
export const deleteRecordType = recordType => apiClient.delete(url.DELETE_RECORD_TYPE + '/' + recordType._id + '/');

// Beach Cleaning
export const getBeachCleaningList = (params) => {
    return apiClient.get(
        `${url.GET_BEACH_CLEANINGS}?${stringifyParams(params)}`
    );
}
export const getBeachCleaning = beachCleaning => apiClient.get(url.BEACH_CLEANING + '/' + encodeURIComponent(beachCleaning));
export const addNewBeachCleaning = beachCleaning => apiClient.post(url.ADD_BEACH_CLEANING, beachCleaning);
export const updateBeachCleaning = beachCleaning => apiClient.put(url.UPDATE_BEACH_CLEANING + '/' + beachCleaning._id, beachCleaning);
export const deleteBeachCleaning = beachCleaning => apiClient.delete(url.DELETE_BEACH_CLEANING + '/' + beachCleaning._id + '/');
export const getBeachCleaningData = beachCleaning => apiClient.get(url.REGISTER_BEACH_CLEANING + '/' + encodeURIComponent(beachCleaning));
export const registerBeachCleaning = beachCleaning => apiClient.post(url.REGISTER_BEACH_CLEANING, beachCleaning);

// Residue Collected
export const getResidueCollectedList = (params) => {
    return apiClient.get(
        `${url.GET_RESIDUE_COLLECTEDS}?${stringifyParams(params)}`
    );
}
export const getResidueCollected = residueCollected => apiClient.get(url.RESIDUE_COLLECTED + '/' + encodeURIComponent(residueCollected));
export const addNewResidueCollected = residueCollected => apiClient.post(url.ADD_RESIDUE_COLLECTED, residueCollected);
export const updateResidueCollected = residueCollected => apiClient.put(url.UPDATE_RESIDUE_COLLECTED + '/' + residueCollected._id, residueCollected);
export const deleteResidueCollected = residueCollected => apiClient.delete(url.DELETE_RESIDUE_COLLECTED + '/' + residueCollected._id);

// Residue Conversion
export const getResidueConversionList = (params) => {
    return apiClient.get(
        `${url.GET_RESIDUE_CONVERSIONS}?${stringifyParams(params)}`
    );
}
export const getResidueConversion = residueConversion => apiClient.get(url.RESIDUE_CONVERSION + '/' + encodeURIComponent(residueConversion));
export const addNewResidueConversion = residueConversion => apiClient.post(url.ADD_RESIDUE_CONVERSION, residueConversion);
export const updateResidueConversion = residueConversion => apiClient.put(url.UPDATE_RESIDUE_CONVERSION + '/' + residueConversion._id, residueConversion);
export const deleteResidueConversion = residueConversion => apiClient.delete(url.DELETE_RESIDUE_CONVERSION + '/' + residueConversion._id);

// Residue Intake (RESPEL — manual intake)
// Backend: oplnk-spv2-residue-backend, ver docs/respel-stock/DECISIONS.md (D-003, D-011, D-012).
// GET lista: query opcional `establishment_id` (bodegas RESPEL de ese centro).
export const getResidueIntakeList = (params) =>
    apiClient.get(`${url.GET_RESIDUE_INTAKES}?${stringifyParams(params)}`);
export const getResidueInboundFeed = params =>
	apiClient.get(
		`${url.GET_RESIDUE_INBOUND_FEED}?${stringifyParams(params)}`,
	);
export const getResidueMovementsFeed = params =>
	apiClient.get(
		`${url.GET_RESIDUE_MOVEMENTS_FEED}?${stringifyParams(params)}`,
	);
export const getResidueIntake = residueIntake =>
    apiClient.get(url.RESIDUE_INTAKE + '/' + encodeURIComponent(residueIntake));
export const addNewResidueIntake = residueIntake =>
    apiClient.post(url.ADD_RESIDUE_INTAKE, residueIntake);
export const updateResidueIntake = residueIntake =>
    apiClient.put(url.UPDATE_RESIDUE_INTAKE + '/' + residueIntake._id, residueIntake);
export const deleteResidueIntake = residueIntake =>
    apiClient.delete(url.DELETE_RESIDUE_INTAKE + '/' + residueIntake._id);

// Warehouse Residue Stock (RESPEL — proyección consolidada del ledger)
// Filtros: warehouse_id, residue_id, respel_only, establishment_id (D-013 + alcance por centro).
export const getWarehouseResidueStock = (params) =>
    apiClient.get(`${url.GET_WAREHOUSE_RESIDUE_STOCKS}?${stringifyParams(params)}`);

// Envío Bodega: arma una guía de despacho consumiendo el stock consolidado (D-005).
// Body esperado:
//   { data_guide: { ...campos de guía }, data_management_stock: { stock_slots: [...] } }
export const warehouseSendFromStock = sendData =>
    apiClient.post(url.WAREHOUSE_SEND_FROM_STOCK, sendData);

/** NP envío bodega por líneas de guía (D-028). */
export const warehouseSendFromGuideLines = sendData =>
	apiClient.post(url.WAREHOUSE_SEND_FROM_GUIDE_LINES, sendData);

export const cancelGuideLinesSend = (guideId, body) =>
	apiClient.post(url.cancelGuideLinesSend(guideId), body);

